import apiClient from './apiClient';

// Συνδρομές γεγονότων προς τρίτα συστήματα (ΛΑ-27, §4.6).
//
// **Δικό του module**, κατά τον κανόνα των παράλληλων κλάδων: νέο αρχείο δεν
// συγκρούεται ποτέ, και ο μεταφορέας παραμένει ο υπάρχων πελάτης.
//
// ⚠ **Το μυστικό υπογραφής επιστρέφεται ΜΟΝΟ από τη `createSubscription`.** Καμία
// άλλη κλήση δεν το φέρνει — ο κατάλογος το αφαιρεί ρητά στη σειριοποίηση του
// μοντέλου. Και, σε αντίθεση με τα κλειδιά πρόσβασης, **δεν υπάρχει διαδρομή
// περιστροφής**: χαμένο μυστικό σημαίνει διαγραφή της συνδρομής και δημιουργία
// νέας. Δηλώνεται εδώ γιατί η οθόνη πρέπει να το πει στον χρήστη **πριν** κρύψει
// το μυστικό, όχι αφού το χάσει.

/** ΛΑ-27: ο κατάλογος των συνδρομών, σελιδοποιημένος. */
export function getSubscriptions({ page = 1 } = {}) {
    return apiClient.getPage(`/api/webhooks?page=${page}`);
}

/**
 * Οι συλλογές, για τον επιλογέα εύρους.
 *
 * Η ίδια διαδρομή με την οθόνη των κλειδιών, και **όχι** νέα: το εύρος μιας
 * συνδρομής είναι μία συλλογή, ακριβώς όπως και του κλειδιού.
 */
export function getCollections() {
    return apiClient.getPage('/api/collections?limit=100');
}

/** Δημιουργία. Η απόκριση φέρει το μυστικό **μία φορά**, στο πεδίο `secret`. */
export function createSubscription({ collection, url, events }) {
    return apiClient.post('/api/webhooks', { collection, url, events });
}

/**
 * Ενεργοποίηση ή απενεργοποίηση.
 *
 * Στέλνεται **μόνο** το `active`: το σχήμα ενημέρωσης είναι `.strict()` και
 * απορρίπτει άγνωστο πεδίο με 422 αντί να το αγνοήσει, οπότε η αποστολή
 * ολόκληρης της συνδρομής θα έσπαγε στην πρώτη προσθήκη πεδίου.
 */
export function setActive(id, active) {
    return apiClient.patch(`/api/webhooks/${id}`, { active });
}

/** Οριστική διαγραφή. Σταματά κάθε μελλοντική παράδοση αυτής της συνδρομής. */
export function deleteSubscription(id) {
    return apiClient.del(`/api/webhooks/${id}`);
}

/**
 * Οι παραδόσεις μιας συνδρομής.
 *
 * ⚠ **Το φορτίο ΔΕΝ ζητείται και δεν επιστρέφεται.** Ο εξυπηρετητής το αφαιρεί
 * ρητά από την προβολή, και η οθόνη δεν έχει καμία παράμετρο να το ζητήσει. Δεν
 * είναι παράλειψη: το φορτίο περιέχει τα δεδομένα του γεγονότος, και ο κατάλογος
 * παραδόσεων είναι οθόνη **διάγνωσης παράδοσης** — κατάσταση, προσπάθειες, αιτία
 * αποτυχίας. Ό,τι χρειάζεται για να καταλάβει κανείς **γιατί δεν έφτασε**, όχι
 * **τι** έστελνε.
 */
export function getDeliveries(id, { page = 1 } = {}) {
    return apiClient.getPage(`/api/webhooks/${id}/deliveries?page=${page}`);
}

/** Επανάληψη μιας αποτυχημένης παράδοσης. Ο εξυπηρετητής απαντά 202. */
export function retryDelivery(id, deliveryId) {
    return apiClient.post(`/api/webhooks/${id}/deliveries/${deliveryId}/retry`);
}

export default {
    getSubscriptions,
    getCollections,
    createSubscription,
    setActive,
    deleteSubscription,
    getDeliveries,
    retryDelivery
};
